import React, { memo } from 'react';
import { BrandLink, Cce, Fs, Place } from './Header.Styles';
export var BrandBox = memo(function (_a) {
    var collapsed = _a.collapsed, prefix = _a.prefix, church = _a.church, place = _a.place, children = _a.children;
    return (React.createElement(BrandLink, { to: "/" },
        children,
        React.createElement("div", { style: { paddingLeft: '1em', fontSize: collapsed ? '13px' : '16px', color: 'inherit' } },
            React.createElement(Fs, null, prefix),
            React.createElement(Cce, null, church),
            React.createElement(Place, null, place))));
});
